import { initializeApp, getApps } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// Web app config — safe to be public, this identifies the project to
// Firebase's servers but grants no access on its own. Actual access control
// lives entirely in the Firestore security rules (see FIRESTORE-RULES.md).
const firebaseConfig = {
    apiKey: "AIzaSyCrf3P90b2cOaeSUTSaI7NNvH6hhrjLsoM",
    authDomain: "crickonnect-44667.firebaseapp.com",
    projectId: "crickonnect-44667",
    storageBucket: "crickonnect-44667.firebasestorage.app",
    messagingSenderId: "376030729446",
    appId: "1:376030729446:web:6424261b77a849d83c1727",
}

// Gatsby renders pages in Node during build (no `window`), and the Firestore
// SDK isn't safe to touch outside a browser context. initializeApp() itself
// is inert enough to call unconditionally, but guard against re-initializing
// on every hot-reload / multiple imports during `gatsby develop`.
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Note: intentionally not initializing Firebase Analytics here — GA4 is
// already wired up site-wide via Google Tag Manager (see gatsby-ssr.js).
// Adding getAnalytics() here would just be a second, redundant GA4 pipe.
export const db = getFirestore(app)
